module.exports = __webpack_public_path__ + "img/location-bold-20x20.b150f025.svg";